import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

import { useErrorContext } from 'contexts/ErrorsNavigationContext/ErrorsNavigationContext';
import { InvoiceDiscrepancy } from 'services/invoiceDiscrepancies/types';
import { InvoiceVerificationDTO, MessageV2DTO } from 'support/types';
import { Button } from 'components/Form/Button';

import { generateEmailBody } from './utils';
import { EmailModal } from './components/EmailModal';

export const GenerateDiscrepancyEmail = ({
  invoice,
  invoiceVerification,
}: {
  invoice: MessageV2DTO;
  invoiceVerification: InvoiceVerificationDTO;
}) => {
  const [generatedEmail, setGeneratedEmail] = useState<string>();
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const { service } = useErrorContext<InvoiceDiscrepancy>();
  const numberOfErrors = service.useNumberOfActiveErrors();
  const errors = service.useErrors();
  const { t } = useTranslation();

  useEffect(() => {
    setGeneratedEmail(undefined);
  }, [errors, invoiceVerification, invoice]);

  if (numberOfErrors === 0) {
    return null;
  }

  return (
    <>
      <Button
        variant="secondary"
        analyticsId="invoiceVerification:generateDiscrepancyEmail"
        LeftIcon={EnvelopeIcon}
        onClick={() => {
          if (!generatedEmail) {
            const emailBody = generateEmailBody({
              invoice,
              invoiceVerification,
              discrepancies: errors,
            });

            setGeneratedEmail(emailBody);
          }
          setEmailModalOpen(true);
        }}
      >
        {t('invoiceVerification:detailsPage.generateDiscrepancyEmail.cta')}
      </Button>
      <EmailModal open={emailModalOpen} onClose={() => setEmailModalOpen(false)} emailBody={generatedEmail || ''} />
    </>
  );
};
